'use client';

import type * as React from 'react';
import { cn } from '@/lib/utils';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer size-4 shrink-0 rounded-tag border border-line-control bg-surface transition-shadow outline-none focus-visible:border-label focus-visible:ring-[3px] focus-visible:ring-label/25 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-err aria-invalid:ring-[3px] aria-invalid:ring-err/20 data-[state=checked]:border-transparent data-[state=checked]:bg-grad-btn data-[state=checked]:text-white data-[state=indeterminate]:border-transparent data-[state=indeterminate]:bg-grad-btn data-[state=indeterminate]:text-white',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <CheckIcon className="size-3.5 in-data-[state=indeterminate]:hidden" />
        <MinusIcon className="hidden size-3.5 in-data-[state=indeterminate]:block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
